import { Grid } from '@material-ui/core';
import { useLookup } from '@ofqual/portal-core/core/hooks';
import React from 'react';
import { SocItemDetailsOfqual } from '../../domain/SocItemDetailsOfqual';
import {
  followupService,
  followupStatusService,
  ragRatingService,
  regulatoryComplianceService,
  usersService,
} from '../../services';
import { Select } from '@ofqual/portal-components/components/Select';
import { Controller } from 'react-hook-form';
import { fieldLabels } from './fieldLabels';
import { UserRole } from '../../domain/userRole';
import { SectionProps } from './SectionProps';

type KloeProps = {
  sectionProps: SectionProps<SocItemDetailsOfqual>;
  kloeType: 'One' | 'Two' | 'Three';
  isRequired?: boolean;
};
export const Kloe: React.FC<KloeProps> = ({
  sectionProps,
  kloeType,
  isRequired = true,
}) => {
  const { control, disabled } = sectionProps;

  const [
    ragRatingLookups,
    followupLookups,
    followupStatusLookups,
    usersLookups,
    regComplianceClosureStatusLookups,
  ] = useLookup(
    ragRatingService,
    followupService,
    followupStatusService,
    {
      service: usersService,
      id: 'upn',
      label: (item) => (item.fullName ? item.fullName : item.upn),
      params: {
        userType: 1,
        role: [UserRole.ITAdmin, UserRole.OfqualSocAdmin],
        active: true,
      },
    },
    regulatoryComplianceService,
  );

  const ragRatingName = `kloe${kloeType}RagRating`;
  const followUpName = `kloe${kloeType}FollowUp`;
  const followUpStatusName = `kloe${kloeType}FollowUpStatus`;
  const leadName = `kloe${kloeType}Lead`;
  const closureStatus = `kloe${kloeType}ClosureStatus`;
  const kloeTypeAsInt = ['One', 'Two', 'Three'].indexOf(kloeType) + 1;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={ragRatingName}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.ragRating + kloeTypeAsInt}
              readOnly={disabled}
              datatest={`${ragRatingName}-field`}
              required={isRequired}
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {ragRatingLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={followUpName}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.followUp + kloeTypeAsInt}
              readOnly={disabled}
              datatest={`${followUpName}-field`}
              required={isRequired}
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {followupLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={followUpStatusName}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.followUpStatus + kloeTypeAsInt}
              readOnly={disabled}
              datatest={`${followUpStatusName}-field`}
              required={isRequired}
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {followupStatusLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={leadName}
          defaultValue={null}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.lead + kloeTypeAsInt}
              readOnly={disabled}
              datatest={`${leadName}-field`}
              required={isRequired}
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {usersLookups}
            </Select>
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={closureStatus}
          defaultValue={null}
          render={({ onChange, ...props }) => (
            <Select
              label={fieldLabels.closureStatus + kloeTypeAsInt}
              readOnly={disabled}
              datatest={`${closureStatus}-field`}
              required={isRequired}
              onChange={(e) => {
                onChange(e);
              }}
              {...props}
            >
              {regComplianceClosureStatusLookups}
            </Select>
          )}
        />
      </Grid>
    </Grid>
  );
};
